function timeFormat(time: any) {
  if (!time) {
    return time;
  }
  let date: any = new Date(time);
  let month: any = addZero(date.getMonth() + 1);
  let day: any = addZero(date.getDate());
  var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
  var hoursMS =
    addZero(date.getHours()) +
    ":" +
    addZero(date.getMinutes()) +
    ":" +
    addZero(date.getSeconds());
  return yearMonthDay + " " + hoursMS;
}
function dateFormat(time: any) {
  if (!time) {
    return time;
  }
  let date: any = new Date(time);
  let month: any = addZero(date.getMonth() + 1);
  let day: any = addZero(date.getDate());
  var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
  return yearMonthDay;
}
function timeFormatMonth(time: any) {
  if (!time) {
    return time;
  }
  let date: any = new Date(time);
  let month: any = addZero(date.getMonth() + 1);
  var monthDay = date.getFullYear() + "-" + month;
  return monthDay;
}
function timeFormatDay(time: any) {
  let t = new Date(time);
  let year = t.getFullYear();
  let month = ("0" + (t.getMonth() + 1)).slice(-2);
  let day = ("0" + t.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
}
function timeFormatSecond(time: any) {
  let t = new Date(time);
  let year = t.getFullYear();
  let month = ("0" + (t.getMonth() + 1)).slice(-2);
  let day = ("0" + t.getDate()).slice(-2);
  let hours = ("0" + t.getHours()).slice(-2);
  let minute = ("0" + t.getMinutes()).slice(-2);
  let second = ("0" + t.getSeconds()).slice(-2);
  return `${year}-${month}-${day} ${hours}:${minute}:${second}`;
}
function timeFormatTime(time: any) {
  let t = new Date(time);
  let year = t.getFullYear();
  let month = ("0" + (t.getMonth() + 1)).slice(-2);
  let day = ("0" + t.getDate()).slice(-2);
  let hours = ("0" + t.getHours()).slice(-2);
  let minute = ("0" + t.getMinutes()).slice(-2);
  let second = ("0" + t.getSeconds()).slice(-2);
  return `${hours}:${minute}:${second}`;
}
function addZero(val: any) {
  if (val < 10) {
    val = "0" + val;
  }
  return val;
}
// lee  判断自身是否含有某属性
function hasProperty(obj: any, key: string): boolean {
  return obj.hasOwnProperty(key);
}
//  lee 本地存储，存
function localSet(k: string, v: string): void {
  localStorage.setItem(k, v);
}
//  lee 本地存储，取
function localGet(k: string): any {
  let _val = localStorage.getItem(k);
  return _val;
}
//  lee double 数字
function doubleNum(n: number): string {
  return n > 9 ? "" + n : "0" + n;
}
//判断浏览器类型
function browserType() {
  let browser = navigator.userAgent;
  let isOpera = browser.indexOf("Opera") > -1; //判断是否Opera浏览器
  let isIE =
    browser.indexOf("compatible") > -1 &&
    browser.indexOf("MSIE") > -1 &&
    !isOpera; //判断是否IE浏览器
  if (isIE) {
    return 1;
  } else {
    return 0;
  }
}
//文件下载
function downloadFile(blob: any, fileName: string) {
  if (browserType()) {
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob); // 创建下载的链接
    link.download = fileName; // 下载后文件名
    link.style.display = "none";
    document.body.appendChild(link);
    link.click(); // 点击下载
    window.URL.revokeObjectURL(link.href); // 释放掉blob对象
    document.body.removeChild(link); // 下载完成移除元素
  }
}
//  是否传参
function whetherSetParam(
  obj: any,
  conditionFuction: any,
  key: string,
  val: any
) {
  if (conditionFuction) {
    obj["" + key + ""] = val;
  }
}
//  排除空值
function setValue(obj: any, arr: any) {
  arr.forEach((item: any) => {
    if (item.value && item.value != "undefined") {
      if (item.type === "string") {
        if (!/undefined/.test(item.value)) {
          obj["" + item.key + ""] = item.value;
        }
      } else if (item.type === "number") {
        if (!isNaN(item.value)) {
          obj["" + item.key + ""] = item.value;
        }
      } else if (item.type === "array") {
        if (item.value.length) {
          obj["" + item.key + ""] = item.value;
        }
      }
    }
  });
  return obj;
}
function arrRemove(arr: any[], val: any) {
  arr.splice(arr.indexOf(val), 1);
}
// js int64string
function jsIntString(arg: string) {
  return /^[0-9]*$/.test(arg);
}
// js 是否是空值
function valueOrNull(arg: any, val?: any) {
  // return typeof Array.isArray(arg) && arg.length ? null : arg ? val : null;
  return arg ? (val ? val : arg) : null;
}
// js 是否是空数组
function arrayOrNull(arg: any, val?: any) {
  // return typeof Array.isArray(arg) && arg.length ? null : arg ? val : null;
  return Array.isArray(arg) && arg.length ? (val ? val : arg) : null;
}
// js 是否是空数组
function timerangeParameter(arg: string[]): string {
  // return typeof Array.isArray(arg) && arg.length ? null : arg ? val : null;
  return arg[0] + " - " + arg[1].split(" ")[0] + " 23:59:59";
}
// page参数类型
type Page = {
  pageIndex: number;
  pageSize: number;
};
function setMetaData() {
  return {
    uid: localStorage.getItem("userid") ? localStorage.getItem("userid") : ""
  };
}
function HTMLEncode(str:any) {
    let tempDom: any = document.createElement("div");
    (tempDom.textContent !== null) ? (tempDom.textContent = str) : (tempDom.innerText = str);
    str = tempDom.innerHTML;
    str = str.replace(' ', '&nbsp;')
    str = str.replace('\n', '<br/>')
    tempDom = null;
    return str;
}
export {
  Page,
  addZero,
  timeFormat,
  dateFormat,
  timeFormatDay,
  timeFormatSecond,
  hasProperty,
  localSet,
  localGet,
  doubleNum,
  downloadFile,
  whetherSetParam,
  setValue,
  arrRemove,
  jsIntString,
  valueOrNull,
  arrayOrNull,
  timerangeParameter,
  setMetaData,
  timeFormatMonth,
  timeFormatTime,
  HTMLEncode
};
